import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { MeResponse } from '@klopotun/contracts';
import { meQueries } from './me-queries.js';

export const useMeQuery = (): UseQueryResult<MeResponse> => useQuery(meQueries.current());
